import { RefreshCw } from 'lucide-react';
import { useVersionCheck } from '../lib/use-version-check';
import { CURRENT_VERSION } from '../lib/changelog';

/**
 * Banner sticky en bottom-right que aparece cuando el hook
 * useVersionCheck detecta que el server tiene una versión más nueva.
 *
 * UX deliberada:
 *  - NO se puede descartar. Una app vieja contra un API nuevo puede
 *    romperse en cualquier momento — no le damos al usuario opción de
 *    "ignorar" para no dejarlo navegando con bugs silenciosos.
 *  - Click recarga la página entera, no solo el bundle (necesitamos que
 *    el browser pida el index.html nuevo y traiga el bundle con el hash
 *    correcto).
 */
export function NewVersionBanner() {
  const { updateAvailable, newVersion } = useVersionCheck();

  if (!updateAvailable) return null;

  return (
    <div className="fixed bottom-4 right-4 z-50 max-w-sm bg-slate-900 text-white rounded-xl shadow-xl border border-slate-700 p-4">
      <div className="flex items-start gap-3">
        <div className="flex-1 min-w-0">
          <h3 className="text-sm font-semibold">Nueva versión disponible</h3>
          <p className="text-xs text-slate-300 mt-1">
            Estás corriendo {CURRENT_VERSION}, hay una versión {newVersion} en el server. Recargá
            para evitar errores.
          </p>
        </div>
        <button
          onClick={() => window.location.reload()}
          className="shrink-0 inline-flex items-center gap-1.5 px-3 py-1.5 bg-emerald-600 hover:bg-emerald-500 text-white text-xs font-medium rounded-lg transition"
        >
          <RefreshCw size={12} />
          Actualizar
        </button>
      </div>
    </div>
  );
}
